import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/common/auth-routes';
import { FeatureFlag } from '@/enums/feature-flag';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';
import ApplicationsPage from '@/pages/applications-page';
import { PageLoader } from './page-loader';

export function ApplicationsRoute() {
  const isReady = useFeatureFlagsReady();
  const hasExternalSamlIdp = useFeatureFlag(FeatureFlag.EXTERNAL_SAML_IDP);

  if (!isReady) {
    return <PageLoader />;
  }

  if (hasExternalSamlIdp) {
    return <Navigate to={`..${ROUTES.AGENTS}`} replace />;
  }

  return <ApplicationsPage />;
}
